import React from 'react';
import { Helmet } from 'react-helmet-async';
import BarHero from '../components/BarHero';
import BarNameGenerator from '../components/BarNameGenerator';
import BarFeatures from '../components/BarFeatures';
import BarHowItWorks from '../components/BarHowItWorks';
import BarTestimonials from '../components/BarTestimonials';
import BarGuide from '../components/BarGuide';
import BarSEOContent from '../components/BarSEOContent';
import BarFAQ from '../components/BarFAQ';
import BarCallToAction from '../components/BarCallToAction';

export default function BarPage() {
  return (
    <>
      <Helmet>
        <title>Bar Name Generator | Create Perfect Bar & Pub Names</title>
      </Helmet>
      <BarHero />
      <BarNameGenerator />
      <BarFeatures />
      <BarHowItWorks />
      <BarTestimonials />
      <BarGuide />
      <BarSEOContent />
      <BarFAQ />
      <BarCallToAction />
    </>
  );
}